import FollowButton from "@components/molecules/follow-button";
import { TopicInterface } from "@carglassgithub/memod-sdk";
import { startTransition, useEffect, useReducer, useState } from "react";
import { sdk } from "@models/api";
import Cookies from "cookie-universal";
import Link from "next/link";
import { useAtomValue, useStore } from "jotai";
import { UserLoggedAtom } from "@models/state/atoms/user-logged.atom";
import {
  AUTH_STATUS,
  AuthModalAtom,
} from "@models/state/atoms/auth-modal.atom";

interface Props {
  topic: TopicInterface;
  onShare?: () => void;
}

const cookies = Cookies();

export function useTopicCard(props: Props) {
  const [follow, setFollow] = useState(false);
  const [showShare, toggleShowShare] = useReducer((state) => !state, false);

  const back = () => {
    window.history.go(-1);
  };
  const config = {
    headers: { Authorization: `Bearer ${cookies.get("refresh_token")}` },
  };

  const logged = useAtomValue(UserLoggedAtom);
  const store = useStore();

  const handleFollow = async () => {
    if (logged) {
      await sdk.http.http
        .post(`/topics/${props.topic?.id}/follow`, {}, config)
        .then((response) => {
          setFollow((state) => !state);
        });
    } else {
      store.set(AuthModalAtom, {
        mode: AUTH_STATUS.SIGN_UP,
        open: true,
      });
    }
  };

  useEffect(() => {
    startTransition(() => setFollow(props.topic?.is_follow === 1 && logged!));

    return () => setFollow(false);
  }, [logged, props.topic?.is_follow, props.topic?.is_follow]);

  return {
    model: { showShare, isFollowing: follow },
    operations: { back, handleFollow, toggleShowShare },
  };
}

export default function TopicCard(props: Props) {
  const { model, operations } = useTopicCard(props);

  return (
    <div className="flex w-[346px] flex-col rounded-lg bg-[#1c1c1e] p-[12px]">
      <div>
        <Link
          href={`/topics/${props.topic.slug}`}
          className="mb-1 pt-[7px] text-2xl text-white"
        >
          {props.topic?.name}
        </Link>
      </div>
      <div className="flex flex-row justify-between">
        <div className="flex flex-row items-center gap-2">
          <strong className="text-base-white">
            {props.topic?.total_memos}
          </strong>
          <span className=" text-base font-semibold text-gray-400">Memos</span>
        </div>
        <FollowButton
          onClick={operations.handleFollow}
          isFollow={model.isFollowing}
          size="small"
          className="h-[30px]"
        />
      </div>
    </div>
  );
}
